import { MappedAnswer } from '../components/context/SurveyPageContext';
import { getHostName } from '../config/env';
import AnswerDTO from '../interfaces/dto/answerDTO';
import SurveyDTO from '../interfaces/dto/surveyDTO';
import { get, post } from '../utils/api';
import questionnaireApiPaths from '../utils/questionnaireApiPaths';
import { redirectToDashboard } from '../utils/redirectMethods';

const questionnaireUrl = `https://questionnaire.${getHostName()}.com`;

const getPersonalSurveys = async (): Promise<SurveyDTO[]> => {
  const url = questionnaireApiPaths.getPersonalSurvey;
  const { data, status } = await get(questionnaireUrl, url);
  if (status === 204) {
    redirectToDashboard();
    throw new Error('Personal Survey is not present!');
  } else if (status === 200 && data.length === 0) {
    redirectToDashboard();
    throw new Error('Personal Survey is empty!');
  }
  return data;
};

const getQuestionnaireAnswers = async (questionnaireId: number): Promise<AnswerDTO[]> => {
  const url = `${questionnaireApiPaths.getQuestionnaireAnswers}/${questionnaireId}`;
  return get(questionnaireUrl, url).then((response) => response.data);
};

const postQuestionnaireAnswers = async (answers: MappedAnswer[]): Promise<void> => {
  const url = questionnaireApiPaths.postQuestionnaireAnswers;
  return post(questionnaireUrl, answers, url).then((response) => response.data);
};

const postMigratePersonalSurveyLastAnswers = async (): Promise<void> => {
  const url = questionnaireApiPaths.postMigratePersonalSurveyLastAnswers;
  return post(questionnaireUrl, {}, url).then((response) => response.data);
};

export {
  getPersonalSurveys,
  getQuestionnaireAnswers,
  postQuestionnaireAnswers,
  postMigratePersonalSurveyLastAnswers,
};
